export enum PAYMENT_METHODS {
	BY_MASTER_NUMBER = 0,
	BY_CREDIT_CARD = 1,
}

export const DEFAULT_CARD: types.topUpAddOns.IFormData = {
	number: '',
	cvv: '',
	date: '',
	holder: '',
	cardType: 'VISA',
	type: 'card',
	tokenId: '',
	saveCard: false,
};

export const URL_PATHS = {
	PREPAID_LOYALTY_ROOT: 'dashboard/gift-program',
	REGISTER_NEW_LOYALTY: 'register-new-loyalty',
	ADD_NEW_SERVICES: 'add-new-services',
	ADD_TOP_UP: 'add-top-up',
};

export const BILLING_TYPE = {
	ENTERPRISE_LOYALTY: 'ENTERPRISE_LOYALTY',
};

export const OFFER_DIRECT_MESSAGE_NAME = 'prepaid_loyalty_manager';
